import { computed, effect, Injectable } from '@angular/core';
import {
    ComponentStoreV2Factory,
} from 'packages/client/src/app/modules/shared/store/common/component-store-v2.factory';
import { InfiniteScrollStore } from 'packages/client/src/app/modules/shared/store/common/infinite-scroll.store';
import { accountFrag } from './organization-settings-mado-transactions.query';

@Injectable()
export class OrganizationSettingsMadoTransactionsStore extends ComponentStoreV2Factory {
    private readonly filter = computed(() => [
        [{
            column: 'organizationId',
            operator: 'EQ',
            value: [String(this.globalGlobalStore.organizationStore.selectedId())],
        }],
        [{
            column: 'fiscalYearId',
            operator: 'EQ',
            value: [String(this.globalGlobalStore.organizationStore.selectedFiscalYearId())],
        }],
    ]);

    public readonly accountScroll = new InfiniteScrollStore(
        this.api.getMadoAccounts,
        { filter: this.filter() },
        false,
        accountFrag,
    );

    constructor() {
        super();

        effect(() => {
            this.accountScroll.changeFilter({ filter: this.filter() });
        });
    }
}
